var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[_c('img',{staticClass:"avatar__image",attrs:{"src":_vm.src,"width":"56","height":"56","alt":"","loading":"lazy","referrerpolicy":"no-referrer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }